import React from "react";
import "./StatusInfo.css";

/** Tooltip body for a Status column: the column's one-line meaning, then what each status value means. */
export default function StatusInfo({intro, statuses}) {
    return (
        <div className="statusInfo">
            <div>{intro}</div>
            <dl className="statusInfoList">
                {statuses.map(([status, meaning]) => (
                    <div key={status} className="statusInfoRow">
                        <dt className="statusInfoName">{status}</dt>
                        <dd className="statusInfoMeaning">{meaning}</dd>
                    </div>
                ))}
            </dl>
        </div>
    );
}
